const height = (val) => {
  if (!val.watch && val.value !== undefined) {
    const str = `${val.value}`;
    if (!isNaN(str)) return `${str}${val.unit ? val.unit : ""}`;
    return str;
  } else {
    const str = `${val}`;
    if (!isNaN(str)) return `${str}${val.unit || "px"}`;
    return str;
  }
};
const parsers = {
  height,
  maxHeight: height,
  width: height,
  maxWidth: height,
  fontSize: height,
};
export default parsers;
